<div *ngIf="data">
  <div class="itemPadding" *ngFor="let x of data">
    <!-- Category -->
    <div class="cursor-pointer d-flex"
         appItemDropper
         [draggable]="editable"
         (dragstart)="onDragStart(x,'object')"
         (dragend)="onDragStop($event)"
         (itemDrop)="onDragEnd(x, 'object')"
         (itemHov)="x.hover = $event; hoverTime(x,$event)"
         [ngClass]="x.hover ? 'hover': ''"
         [attr.id]="x.id"
         >
      <span (click)="showChild(x)" [ngStyle]="{'display' : x.showItems ? 'none' : ''}"><i class="fas fa-chevron-right"></i></span>
      <span (click)="showChild(x)" [ngStyle]="{'display' : !x.showItems ? 'none' : ''}"><i class="fas fa-chevron-down"></i></span>
      <div class="ml-2" contenteditable innerHTML="{{ !!search ? search : x.name }}" (blur)="editCategory($event.target.innerHTML, x)"></div>
    </div>
    <div class="ml-3" [ngStyle]="{'display' : x.showChildren ? '' : 'none' }">
      <app-ops-and-maintain-tree [elementId]="elementId" [data]="x.children" [search]="search" [selectable]="selectable" [editable]="editable" (change)="childChange(x, $event)" (bubble)="bubbler($event)" [selected]="selected" [singleSelect]="singleSelect"></app-ops-and-maintain-tree>
    </div>
    
    <!-- Account -->
    <div [ngStyle]="{'display': x.showItems == true && x.hidden == false ? '' : 'none'}" class="custommargin">
      <div class="d-flex flex-column">
        <div class="itemPadding d-flex" *ngFor="let y of x.items" [attr.id]="y.id">
            <div appItemDropper class="d-flex accounts cursor-pointer w-100" [draggable]="editable" (dragstart)="onDragStart(y,'item')" (itemDrop)="onDragEnd(x, 'item')" (itemHov)="x.hover = $event" (click)="addToSelectedList(y)">
              <div class="flex-column">
                <span class="accountTitle" contenteditable [innerHTML]="y.data.title" (blur)="editItem($event.target.innerHTML, y, 'title')"></span>
                <span class="accountText" contenteditable [innerHTML]="y.data.text" (blur)="editItem($event.target.innerHTML, y, 'text')"></span>
              </div>
              <div class="numberBadges">
                <span class="accountPill bg-yellow" contenteditable [innerHTML]="y.data.propertyCost" (blur)="editItem($event.target.innerHTML, y, 'propertyCost')" *ngIf="propertyManager"></span>
                <span class="accountPill bg-green" contenteditable [innerHTML]="y.data.subscription" (blur)="editItem($event.target.innerHTML, y, 'subscription')" *ngIf="propertyManager"></span>
                <span class="accountPill bg-orange" contenteditable [innerHTML]="y.data.commonCost" (blur)="editItem($event.target.innerHTML, y, 'commonCost')" *ngIf="propertyManager"></span>
                <div class="text-danger ml-3 mb-1" (click)="deleteAccountPlan(y)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                  </svg>                  
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>